import React from "react";
import { useTranslation } from "react-i18next";

import LoginFormContainer from "../components/LoginForm";
import AuthLayout from "../layouts/AuthLayout";

function LoginPage() {
  const { t } = useTranslation('common')
  return (
    <AuthLayout title={t('auth.loginTitle')}>
      <LoginFormContainer />
    </AuthLayout>
  );
}

export default LoginPage;
